import { useState, useCallback } from 'react';
import { apiClient } from '../api/client';

export interface PendingInvitation {
  id: string;
  org_id: string;
  org_name: string;
  invited_by: string;
  role: string;
  created_at: string;
}

export function useInvitations() {
  const [invitations, setInvitations] = useState<PendingInvitation[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchInvitations = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await apiClient.get<PendingInvitation[]>('/members/invitations');
      setInvitations(data || []);
    } catch {
      setInvitations([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const acceptInvitation = async (id: string) => {
    await apiClient.post(`/members/invitations/${id}/accept`, {});
    await fetchInvitations();
  };

  const rejectInvitation = async (id: string) => {
    await apiClient.post(`/members/invitations/${id}/reject`, {});
    await fetchInvitations();
  };

  return { invitations, isLoading, fetchInvitations, acceptInvitation, rejectInvitation };
}
